import _ from 'lodash';

export type TimelineCellConfig = {
  times: number[],
  step: number
};

export default function getTimelineCellConfig(scale: number, width: number, duration: number): TimelineCellConfig {
  const scaledWidth = scale * width;

  const pps = scaledWidth / duration; // pixels per second
  const pp5s = scaledWidth / (duration / 5); // pixels per 5-second block
  const pp10s = scaledWidth / (duration / 10); // pixels per 10-second block
  const pp15s = scaledWidth / (duration / 15); // pixels per 15-second block
  const pp30s = scaledWidth / (duration / 30); // pixels per 30-second block
  const ppm = scaledWidth / (duration / 60); // pixels per minute
  const pp5m = scaledWidth / (duration / 300); // pixels per 5-minute block
  const pp15m = scaledWidth / (duration / 900); // pixels per 15-minute block
  const pp30m = scaledWidth / (duration / 1800); // pixels per 30-minute block
  const pph = scaledWidth / (duration / 3600); // pixels per hour

  const MIN_WIDTH = 75;

  let times, step;
  if (pps > MIN_WIDTH) {
    times = _.range(0, duration);
    step = pps;
  } else if (pp5s > MIN_WIDTH) {
    times = _.range(0, duration, 5);
    step = pp5s;
  } else if (pp10s > MIN_WIDTH) {
    times = _.range(0, duration, 10);
    step = pp10s;
  } else if (pp15s > MIN_WIDTH) {
    times = _.range(0, duration, 15);
    step = pp15s;
  } else if (pp30s > MIN_WIDTH) {
    times = _.range(0, duration, 30);
    step = pp30s;
  } else if (ppm > MIN_WIDTH) {
    times = _.range(0, duration, 60);
    step = ppm;
  } else if (pp5m > MIN_WIDTH) {
    times = _.range(0, duration, 300);
    step = pp5m;
  } else if (pp15m > MIN_WIDTH) {
    times = _.range(0, duration, 900);
    step = pp15m;
  } else if (pp30m > MIN_WIDTH) {
    times = _.range(0, duration, 1800);
    step = pp30m;
  } else {
    times = _.range(0, duration, 3600);
    step = pph;
  }

  return { times, step };
}
